import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';

import activityStream from '@xmatters/redux/reducers/activityStream';
import addUsersToGroup from '@xmatters/redux/reducers/addUsersToGroup';
import changePassword from '@xmatters/redux/reducers/changePassword';
import changes from '@xmatters/redux/reducers/changes';
import table from '@xmatters/redux/reducers/table';

import addUsers from './addUsers';
import alerts from './alerts';
import allEvents from './allEvents';
import conferenceList from './conferenceList';
import conferences from './conferences';
import constantsModal from './constantsModal';
import countries from './countries';
import createGroup from './createGroup';
import currentCommunicationPlan from './currentCommunicationPlan';
import currentOrganization from './currentOrganization';
import alertViews from './alertViews';
import deepLinks from './deepLinks';
import deviceNames from './deviceNames';
import deviceTesting from './deviceTesting';
import deviceTimeframe from './deviceTimeframe';
import deviceTypes from './deviceTypes';
import dismissedAlerts from './dismissedAlerts';
import dynamicTeamsListPage from './dynamicTeamsListPage';
import dynamicTeamObserversList from './dynamicTeamObserversList';
import editProfile from './editProfile';
import endpointsModal from './endpointsModal';
import eventDetails from './eventDetails';
import eventFilters from './eventFilters';
import eventFloodControl from './eventFloodControl';
import eventPropertyDefinitions from './eventPropertyDefinitions';
import events from './events';
import eventSuppressions from './eventSuppressions';
import eventsWidgetSoundSettings from './eventsWidgetSoundSettings';
import eventsWidgetSourceFilter from './eventsWidgetSourceFilter';
import externalConferenceBridgesListPage from './externalConferenceBridgesListPage';
import externalDataPage from './externalDataPage';
import featureToggles from './featureToggles';
import floodControl from './floodControl';
import flowBlockInput from './flowBlockInput';
import flowDesigner from './flowDesigner';
import flowDesignerDebugger from './flowDesignerDebugger';
import flowDesignerDragToConnect from './flowDesignerDragToConnect';
import flowDesignerPalette from './flowDesignerPalette';
import flowDesignerPreferences from './flowDesignerPreferences';
import flowFormSubmission from './flowFormSubmission';
import flowValidations from './flowValidations';
import formMessagesEditor from './formMessagesEditor';
import forms from './forms';
import groupMembersList from './groupMembersList';
import groupListPage from './groupListPage';
import groupObserversList from './groupObserversList';
import groupOnCallList from './groupOnCallList';
import groupPerformance from './groupPerformance';
import groupPerformanceGroupsFilter from './groupPerformanceGroupsFilter';
import groupPerformanceSupervisorFilter from './groupPerformanceSupervisorFilter';
import groupIncidentPerformance from './groupIncidentPerformance';
import groups from './groups';
import helpPopover from './helpPopover';
import images from './images';
import importedUsers from './importedUsers';
import importJobProblemsCount from './importJobProblemsCount';
import importJobs from './importJobs';
import importStatisticsTable from './importStatisticsTable';
import importOnboardingMessages from './importOnboardingMessages';
import importJobUpload from './importJobUpload';
import importMessagesTable from './importMessagesTable';
import incidentManagement from './incidentManagement';
import incidentTasks from './incidentTasks';
import incidentTaskLists from './incidentTaskLists';
import integrationBuilder from './integrationBuilder';
import integrationConfigs from './integrationConfigs';
import libraries from './libraries';
import liveCallRouting from './liveCallRouting';
import loadImportJob from './importJobDetailsReport';
import locationsAndLanguagesPage from './locationsAndLanguages';
import loggedInUser from './loggedInUser';
import installDevice from './installDevice';
import messages from './messages';
import navigation from './navigation';
import noOneOnCall from './noOneOnCall';
import notificationReport from './notificationReport';
import notificationStreamsFilter from './notificationStreamsFilter';
import passwordPolicyForm from './passwordPolicyForm';
import personApiKey from './personApiKey';
import personPropertyDefinitions from './personPropertyDefinitions';
import planIntegrationLogs from './planIntegrationLogs';
import planIntegrations from './planIntegrations';
import plans from './plans';
import postIncidentReportActions from './postIncidentReportActions';
import productPlans from './productPlans';
import productTypeInfo from './productTypeInfo';
import recipientMultiSelect from './recipientMultiSelect';
import recipientSearch from './recipientSearch';
import reloginDialog from './reloginDialog';
import roles from './roles';
import samlForm from './samlForm';
import scriptStepModal from './scriptStepModal';
import search from './search';
import searchFilters from './searchFilters';
import services from './services';
import session from './session';
import settings from './settings';
import savedSearches from './savedSearches';
import shift from './shift';
import shifts from './shifts';
import sidePanel from './sidePanel';
import siteListPage from './sites';
import subscriptions from './subscriptions';
import supervisedUsers from './supervisedUsers';
import supervisors from './supervisors';
import temporaryAbsence from './temporaryAbsence';
import temporaryAbsenceList from './temporaryAbsenceList';
import timeline from './timelineReport';
import toastList from './toast';
import trialRegistration from './trialRegistration';
import triggerFilters from './triggerFilters';
import ttsDictionaryPage from './TtsDictionaryPage';
import userInfoDetails from './userInfoDetails';
import userIntent from './userIntent';
import userListPage from './userListPage';
import userPerformance from './userPerformance';
import userIncidentPerformance from './userIncidentPerformance';
import userProfilePage from './userProfilePage';
import userPropertiesPage from './userPropertiesPage';
import upgradePlans from './upgradePlans';
import whosOnDuty from './whosOnDuty';
import xAgents from './xAgent';
import voiceRecordings from './voiceRecordings';
import workflowHeader from './workflowHeader';
import workflows from './workflows';
import systemAuditReport from './systemAuditReport';
import workflowsPreferences from './workflowsPreferences';
import workflowCreationWizard from './workflowCreationWizard';
import workflowImport from './workflowImport';
import formTriggerTypeAlert from './formTriggerTypeAlert';
import xmApi from './xmApi';
// TODO: remove after removing remainder of GWT-injected react inputs:
import gwtInputs from './gwtInputs';

export default combineReducers({
  activityStream,
  addUsers,
  addUsersToGroup,
  alerts,
  allEvents,
  changePassword,
  changes,
  conferenceList,
  conferences,
  constantsModal,
  countries,
  createGroup,
  currentCommunicationPlan,
  currentOrganization,
  alertViews,
  deepLinks,
  deviceNames,
  deviceTesting,
  deviceTimeframe,
  deviceTypes,
  dismissedAlerts,
  dynamicTeamsListPage,
  dynamicTeamObserversList,
  editProfile,
  endpointsModal,
  eventDetails,
  eventFilters,
  eventFloodControl,
  eventPropertyDefinitions,
  events,
  eventSuppressions,
  eventsWidgetSoundSettings,
  eventsWidgetSourceFilter,
  externalConferenceBridgesListPage,
  externalDataPage,
  featureToggles,
  floodControl,
  flowBlockInput,
  flowDesigner,
  flowDesignerDebugger,
  flowDesignerDragToConnect,
  flowDesignerPalette,
  flowDesignerPreferences,
  flowFormSubmission,
  flowValidations,
  form,
  forms,
  formMessagesEditor,
  formTriggerTypeAlert,
  groupMembersList,
  groupListPage,
  groupObserversList,
  groupOnCallList,
  groupPerformance,
  groupPerformanceGroupsFilter,
  groupPerformanceSupervisorFilter,
  groupIncidentPerformance,
  groups,
  gwtInputs,
  helpPopover,
  images,
  importedUsers,
  importJobProblemsCount,
  importJobs,
  importStatisticsTable,
  importJobUpload,
  importMessagesTable,
  importOnboardingMessages,
  incidentManagement,
  incidentTasks,
  incidentTaskLists,
  integrationBuilder,
  integrationConfigs,
  libraries,
  liveCallRouting,
  loadImportJob,
  loggedInUser,
  installDevice,
  messages,
  navigation,
  noOneOnCall,
  notificationReport,
  notificationStreamsFilter,
  passwordPolicyForm,
  personApiKey,
  personPropertyDefinitions,
  planIntegrationLogs,
  planIntegrations,
  plans,
  postIncidentReportActions,
  productPlans,
  productTypeInfo,
  recipientMultiSelect,
  recipientSearch,
  reloginDialog,
  roles,
  savedSearches,
  samlForm,
  scriptStepModal,
  search,
  searchFilters,
  services,
  session,
  settings,
  shift,
  shifts,
  sidePanel,
  siteListPage,
  locationsAndLanguagesPage,
  subscriptions,
  supervisedUsers,
  supervisors,
  table,
  temporaryAbsence,
  temporaryAbsenceList,
  timeline,
  toastList,
  trialRegistration,
  triggerFilters,
  ttsDictionaryPage,
  userInfoDetails,
  userIntent,
  userListPage,
  userPerformance,
  userIncidentPerformance,
  userProfilePage,
  userPropertiesPage,
  upgradePlans,
  whosOnDuty,
  xAgents,
  voiceRecordings,
  workflowHeader,
  workflows,
  systemAuditReport,
  workflowsPreferences,
  workflowCreationWizard,
  workflowImport,
  xmApi,
});
